module.exports = __webpack_public_path__ + "img/chatbots_notifications.e128ea2d.png";